import React from 'react';
import './LogoutConfirmModal.css';

interface LogoutConfirmModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * 确认注销对话框
 */
export const LogoutConfirmModal: React.FC<LogoutConfirmModalProps> = ({
  visible,
  onCancel,
  onConfirm,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <div className="logout-confirm-modal-overlay" onClick={onCancel}>
      <div className="logout-confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="logout-confirm-title">确认注销</div>
        <div className="logout-confirm-content">
          账户注销后，将无法恢复该账号，敬请慎重考虑。
        </div>
        <div className="logout-confirm-actions">
          <button className="logout-confirm-cancel" onClick={onCancel}>
            再想想
          </button>
          <button className="logout-confirm-submit" onClick={onConfirm}>
            确认注销
          </button>
        </div>
      </div>
    </div>
  );
};

